import { IdentifiableObject } from '@data/common/IdentifiableObject';
import { Transform } from 'class-transformer';
import { DateUtil } from '@shared/util/date.util';
import { NotificationActionType } from 'app/view/notifications/data/NotificationActionType';

export class NotificationDTO extends IdentifiableObject {
  public action: NotificationActionType;

  @Transform(DateUtil.dateTimeConversion)
  public createdDate: Date;

  public hasBeenRead: boolean;

  public message: string;

  public title: string;
}
